// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1VDUq","footer":"ModalError_footer__3oZQo"};